import React, { useEffect, useRef } from 'react'

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import mongoIcon from '../images/file_type_mongo_icon_130383.svg';
import postgresIcon from '../images/folder_postgres_icon_161286.svg';
import mysqlIcon from '../images/mysql-svgrepo-com.svg';
import socketioIcon from '../images/socket-io-svgrepo-com.svg';
import expressIcon from '../images/expressjs-icon.svg';
import gitIcon from '../images/git-svgrepo-com.svg';
import githubIcon from '../images/github-color-svgrepo-com.svg';
import awsIcon from '../images/aws-svgrepo-com.svg';
import doIcon from '../images/digital-ocean-svgrepo-com.svg';
import vercelIcon from '../images/vercel-svgrepo-com.svg';
import firebaseIcon from '../images/firebase-svgrepo-com.svg';
import dockerIcon from '../images/docker-logo-svgrepo-com.svg';

const Stack = ({setActiveStack}) => {
   

    const [divStack, inViewStack] = useInView({ threshold: 0.5});
    
        useEffect(() => {
            if (inViewStack) {
                setActiveStack(true); // Activa el estado del navbar
            } else {
                setActiveStack(false); // Desactiva el estado cuando ya no está visible
            }
        }, [inViewStack, setActiveStack]);

        const divRefOne = useRef(null);
        const divRefTwo = useRef(null);
        const divRefThree = useRef(null);
        const divRefFour = useRef(null);
        const divRefFive = useRef(null);
        const divRefSix = useRef(null);
        const divRefSeven = useRef(null);
        const divRefEight = useRef(null);
        const divRefNine = useRef(null);
    
        const [refOne, inViewOne] = useInView({ threshold: 0.5, triggerOnce:true });
        const [refTwo, inViewTwo] = useInView({ threshold: 0.5, triggerOnce:true });
        const [refThree, inViewThree] = useInView({ threshold: 0.5, triggerOnce:true });
        const [refFour, inViewFour] = useInView({ threshold: 0.5, triggerOnce:true });
        const [refFive, inViewFive] = useInView({ threshold: 0.5, triggerOnce:true });
        const [refSix, inViewSix] = useInView({ threshold: 0.5, triggerOnce:true });
        const [refSeven, inViewSeven] = useInView({ threshold: 0.5, triggerOnce:true });
        const [refEight, inViewEight] = useInView({ threshold: 0.5, triggerOnce:true });
        const [refNine, inViewNine] = useInView({ threshold: 0.5, triggerOnce:true });

    return (
    <div ref={divStack} id="stack" style={{paddingTop: '100px'}}  className="container px-4 items-center text-center justify-center"  >
        <h2 className="text-center mt-0">Tecnologías</h2>
        <hr className="divider" />

        <div className='row g-4'>

            <motion.div
            ref={divRefOne}
            className={`animate ${inViewOne ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewOne ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>
                <div ref={refOne} className="" style={{width: '18rem'}}>
                    <i class="fab fa-node-js fa-3x icon-stack"></i>
                    <div className="card-body text-center">
                        <h5 className="card-title">NodeJS</h5>
                        <div className='d-flex justify-content-center'>
                            <p className="card-text">Node.js® is an open-source, cross-platform JavaScript runtime environment.</p>
                            <a href="https://nodejs.org/en/" target={'_blank'} rel= {'noreferrer'} className="btn btn-primary btn-card mx-auto">Ir a NodeJS</a>

                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
            ref={divRefTwo}
            className={`animate ${inViewTwo ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewTwo ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>

                <div ref={refTwo} className="" style={{width: '18rem'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.75 15.875" height="60" width="120" fill="#ea2845"><path d="M8.407 2.617c-.077 0-.15.017-.215.04.14.094.218.218.257.36.003.02.008.033.01.052s.006.033.006.05c.01.243-.063.273-.116.417a.59.59 0 0 0 .039.543.33.33 0 0 0 .033.061c-.105-.698.477-.803.585-1.02.008-.2-.15-.317-.273-.406a.61.61 0 0 0-.326-.094zm.877.157c-.01.063-.003.047-.006.08l-.006.072-.02.066a.62.62 0 0 1-.022.066l-.03.063c-.008.01-.014.022-.022.033l-.017.025-.04.055c-.017.017-.03.036-.05.05s-.033.033-.052.047c-.058.044-.124.077-.185.12-.02.014-.04.025-.055.04s-.036.028-.052.044-.033.033-.05.052-.03.036-.04.055l-.04.058-.03.063-.022.063-.02.07c-.003.01-.003.025-.006.036s-.003.022-.006.033l-.003.07a.3.3 0 0 0 .003.05c0 .022.003.044.008.07s.008.044.014.066l.022.066c.006.014.014.028.02.04l-.634-.246-.32-.083-.174-.04a5.12 5.12 0 0 0-.502-.074 4.65 4.65 0 0 0-.508-.028l-.36.014a5.25 5.25 0 0 0-.505.061l-.124.022-.248.055-.124.033-.12.052-.09.04-.09.044c-.008.003-.014.006-.02.008l-.086.044c-.02.008-.04.02-.055.028-.008.006-.02.01-.025.014l-.072.04c-.025.014-.047.028-.066.04l-.055.04-.06.044-.047.04c-.03.022-.044.036-.058.047l-.06.058-.055.052-.047.05c-.006.006-.014.01-.02.017-.014.017-.03.033-.047.05l-.074.08-.15.143a1.57 1.57 0 0 1-.154.121l-.166.105a1.68 1.68 0 0 1-.174.083c-.058.025-.12.047-.18.066-.116.025-.234.072-.337.08-.022 0-.047.006-.07.008l-.07.017-.066.025c-.022.008-.044.02-.066.03s-.04.025-.06.04a.45.45 0 0 0-.055.047c-.02.014-.04.033-.055.05l-.047.055c-.014.022-.03.04-.04.063s-.028.04-.04.063l-.03.072-.025.072-.014.066c-.008.033-.008.066-.01.083s-.006.036-.006.055c0 .01 0 .025.003.036.003.02.006.036.01.052l.02.05c.008.02.02.036.03.052l.036.05.047.044c.017.017.033.03.052.044.066.058.083.077.168.12.014.008.028.014.044.022.014.04.02.06.025.083s.014.047.022.066l.022.05.04.074.04.058.047.052c.017.017.033.03.052.047l.055.04a.44.44 0 0 0 .061.036c.02.01.04.022.063.03.017.008.036.014.055.02s.036.01.047.014c-.008.15-.01.3.01.34.025.055.146-.113.268-.306-.017.2-.028.414 0 .48s.196-.146.34-.384c1.956-.452 3.74.9 3.93 2.808-.036-.298-.403-.463-.57-.422-.083.204-.223.466-.45.63a1.77 1.77 0 0 0-.028-.552c-.06.254-.18.49-.342.695a.77.77 0 0 1-.662-.298c-.01-.008-.014-.025-.022-.036L5.5 10.1c-.008-.02-.014-.04-.017-.058s-.003-.04-.003-.06v-.04c.003-.02.008-.04.014-.058l.02-.058c.01-.02.02-.04.033-.058.047-.132.047-.24-.04-.303-.017-.01-.033-.02-.052-.028-.01-.003-.025-.008-.036-.01l-.022-.008-.058-.014a.21.21 0 0 0-.058-.008.45.45 0 0 0-.061-.006c-.014 0-.028.003-.04.003-.022 0-.04.003-.06.008l-.058.01-.058.02-.055.025-.052.028c-.643.42-.26 1.4.18 1.686-.166.03-.334.066-.38.102.113.077.237.138.367.2l.447.132a2.56 2.56 0 0 0 .695.052c1.222-.086 2.224-1.015 2.406-2.24l.017.072.025.154c.006.028.008.052.01.074l.006.083.006.09v.044c0 .014.003.03.003.044s-.003.033-.003.05v.04c0 .02-.003.036-.003.055 0 .01 0 .022-.003.036l-.003.06c-.003.008-.003.017-.003.025l-.008.063c0 .008 0 .017-.003.025l-.01.08v.005l-.017.077-.017.083-.044.17-.028.088-.06.16-.033.08-.04.077c-.003.008-.006.014-.008.02a2.64 2.64 0 0 1-.781.935c-.022.014-.044.03-.066.047-.006.006-.014.008-.02.014l-.06.04.008.017h.003l.116-.017h.003l.215-.04c.02-.003.04-.008.06-.014l.04-.008.058-.01.05-.014a5.23 5.23 0 0 0 .8-.265 4.42 4.42 0 0 1-1.713 1.399 4.54 4.54 0 0 0 .941-.163c1.112-.328 2.047-1.076 2.607-2.083-.113.637-.367 1.244-.742 1.774.268-.177.513-.38.737-.612.618-.646 1.024-1.465 1.16-2.345.094.436.12.886.08 1.33 1.992-2.778.166-5.658-.6-6.417-.01.02-.014.052-.016.086l-.028.185-.047.182-.066.177-.083.168-.1.157-.113.15c-.04.05-.086.094-.13.138l-.08.07-.063.055a1.54 1.54 0 0 1-.154.108l-.163.094-.174.077a1.94 1.94 0 0 1-.179.058l-.185.04c-.063.01-.127.017-.188.022l-.132.006c-.063 0-.127-.006-.188-.01a1.38 1.38 0 0 1-.188-.027c-.063-.01-.124-.028-.185-.047h-.003l.182-.022.185-.04.18-.058c.06-.022.12-.05.174-.077a1.93 1.93 0 0 0 .166-.091l.154-.1a1.51 1.51 0 0 0 .141-.124 1.5 1.5 0 0 0 .13-.135l.116-.15c.006-.008.01-.02.017-.028l.08-.132.083-.168.066-.177c.02-.058.033-.12.047-.18l.028-.185.01-.188-.005-.132-.022-.185-.04-.185-.06-.177c-.022-.058-.05-.116-.077-.17l-.094-.163-.1-.152-.127-.14-.072-.07-.383-.27c-.02-.01-.036-.02-.055-.028-.09-.058-.177-.088-.262-.116z" fill-rule="evenodd"/><path d="M14.806 9.806a.87.87 0 0 1 .201-.067c.155-.025.243-.046.268-.063.042-.025.07-.06.084-.092.017-.06.025-.18.025-.373v-.365l.004-.298-.013-.445V7.84c0-.176-.013-.323-.042-.432-.008-.042-.046-.084-.105-.126-.08-.06-.2-.113-.398-.168l-.004-.2.096-.02c.03-.004.143-.034.34-.084l.298-.117.07-.038a1.07 1.07 0 0 1 .113-.084 1.73 1.73 0 0 0 .302-.306l.222-.017-.008.474c-.004.046-.004.084-.004.113l.004.193c.235-.2.445-.34.638-.42a1.82 1.82 0 0 1 .71-.155 1.24 1.24 0 0 1 .696.197c.196.13.33.28.4.45s.092.52.092 1.036l-.017 1.376a.36.36 0 0 0 .034.159.73.73 0 0 0 .235.063l.206.038a.23.23 0 0 1 .038.134l-.004.138-.826-.06-.243.008h-.193l-.558.042h-.143c-.004-.038-.004-.063-.004-.084l.008-.164c.038-.008.138-.02.294-.042.042-.004.088-.017.143-.03.055-.02.088-.046.096-.067.02-.05.034-.138.034-.273l-.008-.545.004-.487c0-.596-.034-.965-.1-1.107-.1-.214-.268-.32-.482-.32a1.14 1.14 0 0 0-.487.122 2.09 2.09 0 0 0-.524.365l-.008.07.008.264-.004.28.017.675-.008.105c0 .457.017.717.055.776s.176.122.42.193l.013.105c0 .034-.013.084-.03.155l-.222.004a2.34 2.34 0 0 1-.277-.025L15.8 10l-.973.03a.22.22 0 0 1-.017-.088l.004-.134zM19.76 7.8c.075-.24.138-.398.197-.474.155-.23.323-.4.5-.54s.34-.214.482-.256a1.68 1.68 0 0 1 .453-.08 2.56 2.56 0 0 1 .638.063 1.19 1.19 0 0 1 .411.172 2.17 2.17 0 0 1 .377.331 1.38 1.38 0 0 1 .231.398 1.6 1.6 0 0 1 .105.549l-.47-.008a19.66 19.66 0 0 1-.851-.038l-.336-.017-.453.004h-.365l-.008.1c0 .15.02.306.055.474s.092.306.164.432a1.18 1.18 0 0 0 .273.319c.1.092.222.155.336.197l.243.08.436-.02a2.08 2.08 0 0 0 .352-.105 2.21 2.21 0 0 0 .373-.226l.256.2c-.247.268-.508.47-.772.6s-.562.18-.9.18c-.222 0-.403-.017-.545-.06a1.65 1.65 0 0 1-.508-.23 1.87 1.87 0 0 1-.4-.386c-.12-.15-.193-.315-.247-.478-.067-.214-.105-.386-.105-.512a3.33 3.33 0 0 1 .06-.663zm2.45-.18c-.004-.16-.034-.306-.092-.453s-.15-.252-.277-.33a.68.68 0 0 0-.373-.122c-.2 0-.357.084-.512.247s-.235.4-.256.675l.96.004.26-.013.176-.013.113.004zm1.6 1.222a1.05 1.05 0 0 1 .185-.025l.088.004.038.042.302.487c.096.113.193.206.3.277.063.042.164.092.302.138a.87.87 0 0 0 .298.05.65.65 0 0 0 .453-.168c.126-.117.2-.24.2-.373 0-.088-.025-.164-.07-.226s-.143-.126-.285-.2c-.07-.03-.247-.08-.533-.15L24.6 8.56a1.14 1.14 0 0 1-.352-.21.95.95 0 0 1-.235-.306c-.07-.16-.1-.298-.1-.4 0-.214.034-.386.092-.524a1.16 1.16 0 0 1 .264-.361c.08-.08.2-.15.365-.214a1.46 1.46 0 0 1 .528-.096 3.88 3.88 0 0 1 .705.055 1.89 1.89 0 0 1 .512.164c.02.063.042.214.075.445l.046.415c0 .02-.004.042-.013.063a.72.72 0 0 1-.185.034c-.025 0-.067-.004-.122-.008a2.33 2.33 0 0 1-.1-.176c-.134-.252-.273-.428-.415-.528s-.302-.155-.5-.155-.357.06-.487.168a.42.42 0 0 0-.143.336c0 .092.05.185.15.28s.268.172.512.222c.37.08.642.164.814.243.252.117.432.26.533.42s.155.344.155.554c0 .327-.126.6-.373.818s-.6.323-1.074.323a6.11 6.11 0 0 1-.482-.042c-.117-.013-.256-.042-.415-.084a3.82 3.82 0 0 1-.31-.122.22.22 0 0 1-.067-.06c-.008-.025-.03-.143-.055-.352l-.07-.617zm3.456-2.014c.33-.138.57-.277.717-.4s.306-.357.474-.66h.24a.72.72 0 0 1 .038.231l-.004.344-.013.247.004.096.096.004.394-.017.315-.008a.97.97 0 0 1 .029.201c0 .067-.013.143-.034.226a1.57 1.57 0 0 1-.21.017c-.02 0-.067 0-.134-.008h-.218l-.076-.004-.2.008-.008 1.6.017.583a.59.59 0 0 0 .101.222.5.5 0 0 0 .214.046c.075 0 .13-.008.168-.02s.1-.055.185-.122c.017-.017.046-.034.08-.06a.88.88 0 0 1 .168.159l.017.05a1.02 1.02 0 0 1-.419.365c-.176.088-.365.13-.566.13-.264 0-.474-.084-.638-.247s-.243-.424-.243-.772l.017-.738V7.1l-.13-.004-.306.004-.055-.013a.12.12 0 0 1-.025-.07l.008-.2z"/> </svg>
                    <div className="card-body">
                        <h5 className="card-title">NestJS</h5>
                        <div className='d-flex justify-content-center'>
                            <p className="card-text">A progressive Node.js framework for building efficient, reliable and scalable server-side applications. </p>
                            <a href="https://nestjs.com/" target={'_blank'} rel= {'noreferrer'}  className="btn btn-primary btn-card">Ir a Nestjs</a>
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
            ref={divRefThree}
            className={`animate ${inViewThree ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewThree ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>

                <div ref={refThree} className="" style={{width: '18rem'}}>
                    <div className="card-body">
                        <img alt='Express' className='' src={expressIcon}/>
                        <h5 className="card-title">ExpressJS</h5>
                        <div className='d-flex justify-content-center'>
                            <p className="card-text">Fast, unopinionated, minimalist web framework for Node.js</p>
                            <a href="https://expressjs.com/" target={'_blank'} rel= {'noreferrer'}  className="btn btn-primary btn-card">Ir a ExpressJS</a>
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
            ref={divRefFour}
            className={`animate ${inViewFour ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewFour ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>

                <div ref={refFour} className="" style={{width: '18rem'}}>
                    <i class="fab fa-react fa-3x icon-stack"></i>
                    <div className="card-body">
                        <h5 className="card-title">ReactJS</h5>
                        <div className='d-flex justify-content-center'>
                            <p className="card-text">React is a JavaScript library for building user interfaces</p>
                            <a href="https://reactjs.org" target={'_blank'} rel= {'noreferrer'}  className="btn btn-primary btn-card">Ir a React</a>
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
            ref={divRefFive}
            className={`animate ${inViewFive ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewFive ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>

                <div ref={refFive} className="" style={{width: '18rem'}}>   
                    <div className="card-body">
                        <img alt='Socket IO' className='' src={socketioIcon}/>
                        <h5 className="card-title">Socket IO</h5>
                        <div className='d-flex justify-content-center'>
                            <p className="card-text">Bidirectional and low-latency communication for every platform</p>
                            <a href="https://socket.io/" target={'_blank'} rel= {'noreferrer'}  className="btn btn-primary btn-card">Ir a Socket IO</a>
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
            ref={divRefSix}
            className={`animate ${inViewSix ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewSix ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>
                
                <div ref={refSix} className="" style={{width: '18rem'}}>
                    <i class="fas fa-database fa-2x icon-stack" ></i>
                    <div className="card-body">
                        <h5 className="card-title">Databases</h5>
                        <div className='row d-flex content-stack'>
                            <div className='col'>
                                <img alt='mongodb' className='icon-db' src={mongoIcon}/>
                                <p style={{fontSize:'10px', marginTop: 0}}>MongoDB</p>
                            </div>
                            <div className='col'>
                                <img alt='Postgres' className='icon-db' src={postgresIcon}/>
                                <p style={{fontSize:'10px', marginTop: 0}}>PostgreSQL</p>
                            </div>
                            <div className='col'>
                                <img alt='mysql' className='icon-db' src={mysqlIcon}/>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>


            <motion.div
            ref={divRefSeven}
            className={`animate ${inViewSeven ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewSeven ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>

                <div ref={refSeven} className="" style={{width: '18rem'}}>
                    <div className="card-body">
                        <i class="fas fa-code-branch fa-2x "></i>
                        <h5 className="card-title">Versioning</h5>
                        <div className='row d-flex content-stack'>
                            <div className='col'>
                                <img alt='Git' className='icon-db' src={gitIcon}/>
                                {/* <p style={{fontSize:'10px', marginTop: 0}}>Git</p> */}
                            </div>
                            <div className='col'>
                                <img alt='Github' className='icon-small' src={githubIcon}/>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
            ref={divRefEight}
            className={`animate ${inViewEight ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewEight ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>

                <div ref={refEight} className="" style={{width: '18rem'}}>
                    <div className="card-body">
                        <i class="fas fa-cloud-upload-alt fa-2x"></i>
                        <h5 className="card-title">Cloud</h5>
                        <div className='row d-flex content-stack'>
                            <div className='col'>
                                <img alt='AWS' className='icon-db' src={awsIcon}/>
                                {/* <p style={{fontSize:'10px', marginTop: 0}}>Git</p> */}
                            </div>
                            <div className='col'>
                                <img alt='Digital Ocean' className='icon-db' src={doIcon}/>
                            </div>
                            <div className='col'>
                                <img alt='Heroku' className='icon-db' src={vercelIcon}/>
                            </div>
                            <div className='col'>
                                <img alt='Netlify' className='icon-db' src={firebaseIcon}/>
                                <p style={{fontSize:'10px', marginTop: 0}}><i>Firebase</i></p>
                            </div>

                        
                        </div>
                    </div>
                </div>
            </motion.div>

            <motion.div
            ref={divRefNine}
            className={`animate ${inViewNine ? 'show' : ''} card col-12 col-md-6 col-lg-4 align-items-center`}
            initial={{ opacity: 0, x: 100 }}
            animate={inViewNine ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}>

                <div ref={refNine} className="" style={{width: '18rem'}}>
                    <div className="card-body">
        
                        <i class="fas fa-cogs fa-2x"></i>
                        <h5 className="card-title">DevOps</h5>
                        <div className='row d-flex content-stack'>
                            <div className='col'>
                                <img alt='Docker' className='icon-small' src={dockerIcon}/>
                                {/* <p style={{fontSize:'10px', marginTop: 0}}>Git</p> */}
                            </div>
                            <div className='col'>
                                <img alt='GitHub' className='icon-small' src={githubIcon}/>
                                <p style={{fontSize:'10px', marginTop: 0, marginLeft: '10px'}}><strong>Github Actions</strong></p>
                            </div>

                        </div>
                    </div>
                </div>
            </motion.div>

            
        </div>


    </div>
        
  )
}

export default Stack
